export const companyUsers = {
  items: [
    {
      id: 1,
      fullName: 'Ion Pop',
      role: 0,
      phoneNumber: '(898)230-1080',
      emailAddress: 'dan.woodkin@mail.com',
      customerNo: 'CL01001',
      color: 'Rosu'
    },
    {
      id: 2,
      fullName: 'Marilyn Gordon',
      role: 1,
      phoneNumber: '(666)239-6769',
      emailAddress: 'aaron.mccoy@mail.com',
      customerNo: 'CL01002',
      color: 'Portocaliu'
    },
    {
      id: 3,
      fullName: 'Ion Pop',
      role: 0,
      phoneNumber: '(898)230-1080',
      emailAddress: 'dan.woodkin@mail.com',
      customerNo: 'CL01001',
      color: 'Rosu'
    },
    {
      id: 4,
      fullName: 'Marilyn Gordon',
      role: 1,
      phoneNumber: '(666)239-6769',
      emailAddress: 'aaron.mccoy@mail.com',
      customerNo: 'CL01002',
      color: 'Portocaliu'
    },
    {
      id: 5,
      fullName: 'Ion Pop',
      role: 0,
      phoneNumber: '(898)230-1080',
      emailAddress: 'dan.woodkin@mail.com',
      customerNo: 'CL01001',
      color: 'Rosu'
    },
    {
      id: 6,
      fullName: 'Marilyn Gordon',
      role: 1,
      phoneNumber: '(666)239-6769',
      emailAddress: 'aaron.mccoy@mail.com',
      customerNo: 'CL01002',
      color: 'Portocaliu'
    },
    {
      id: 7,
      fullName: 'Ion Pop',
      role: 0,
      phoneNumber: '(898)230-1080',
      emailAddress: 'dan.woodkin@mail.com',
      customerNo: 'CL01001',
      color: 'Rosu'
    },
    {
      id: 8,
      fullName: 'Marilyn Gordon',
      role: 1,
      phoneNumber: '(666)239-6769',
      emailAddress: 'aaron.mccoy@mail.com',
      customerNo: 'CL01002',
      color: 'Portocaliu'
    },
    {
      id: 9,
      fullName: 'Ion Pop',
      role: 0,
      phoneNumber: '(898)230-1080',
      emailAddress: 'dan.woodkin@mail.com',
      customerNo: 'CL01001',
      color: 'Rosu'
    },
    {
      id: 10,
      fullName: 'Marilyn Gordon',
      position: 'User',
      role: 1,
      phoneNumber: '(666)239-6769',
      emailAddress: 'aaron.mccoy@mail.com',
      customerNo: 'CL01002',
      color: 'Portocaliu'
    }
  ],
  total: 12,
  totalPages: 2
};

export const companyUserDetails = {
  id: 1,
  firstName: 'Ion',
  lastName: 'Pop',
  role: 0,
  phoneNumber: '(898)230-1080',
  emailAddress: 'dan.woodkin@mail.com',
  customerNo: 'CL01001',
  reportsAccess: true,
  viewCardTransactions: false,
  viewCardSettings: true,
  editCardsAccess: false,
  newCardRequestAccess: true,
  viewCardHistory: false,
  color: 'Rosu'
};
